// Stock photos + copy for the homepage "The Index" tiles. Approved provider
// photos from /api/landing/index-tiles are shown first; these fill the gaps.
const PX = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1000`;
const US = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000`;

// Aspect ratios are intentionally mixed: tall portraits, square pins,
// and a landscape or two, so columns settle at different heights.
export const TILES = [
  {
    id: 'locs_braids_protective',
    label: 'Locs, Braids & Protective',
    kicker: 'Vol. I',
    blurb: 'Knotless, faux locs, twists, cornrows. The craft that built the platform, now open to every texture.',
    photos: [
      { image: PX(19743922), alt: 'Studio portrait of a young woman with long braided hair', credit: { name: 'Boko Shots', url: 'https://www.pexels.com/@boko-shots-812604874/' } },
      { image: US('1527203561188-dae1bc1a417f'), alt: 'Profile of a woman with a long braided ponytail against a tan backdrop' },
      { image: US('1592520113018-180c8bc831c9'), alt: 'Portrait of a woman with long box braids in a white shirt' },
    ],
    accent: '#D4AF37',
    aspect: 'aspect-[3/4]',
  },
  {
    id: 'barbering_grooming',
    label: 'Barbering & Grooming',
    kicker: 'Vol. II',
    blurb: 'Skin fades, line-ups, beard sculpting.',
    photos: [
      { image: PX(13138585), alt: 'Barber giving a precise haircut to a client in a modern barbershop', credit: { name: 'Marvin Sacdalan', url: 'https://www.pexels.com/@marvin-sacdalan-276316567/' } },
      { image: US('1599351431202-1e0f0137899a'), alt: 'Barber using a straight razor to sharpen a client’s line-up' },
      { image: US('1657105052497-f996284ffff8'), alt: 'Barber trimming a client’s hair with comb and thinning shears' },
    ],
    accent: '#475569',
    aspect: 'aspect-[4/3]',
  },
  {
    id: 'hair_styling_care',
    label: 'Hair Care & Styling',
    kicker: 'Vol. III',
    blurb: 'Silk presses, blow-outs, European styling. Every texture welcome.',
    photos: [
      { image: PX(17784002), alt: 'Hairdresser skilfully cutting a client\u2019s hair in a contemporary salon', credit: { name: 'Alex Ozerov-Meyer', url: 'https://www.pexels.com/@alex-ozerov-meyer-651936162/' } },
      { image: US('1560264641-1b5191cc63e2'), alt: 'Close-up of defined, glossy curls' },
      { image: US('1580618672591-eb180b1a973f'), alt: 'Stylist giving a client a round-brush blow-dry' },
    ],
    accent: '#E11D48',
    aspect: 'aspect-[4/5]',
  },
  {
    id: 'aesthetics_skin',
    label: 'Aesthetics & Skin',
    kicker: 'Vol. IV',
    blurb: 'Facials and skin therapy for every skin type.',
    photos: [
      { image: PX(7479815), alt: 'Two women of different heritages in sheet masks and towels at a spa', credit: { name: 'Angela Roma', url: 'https://www.pexels.com/@angela-roma/' } },
      { image: US('1570172619644-dfd03ed5d881'), alt: 'Therapist applying a clay mask during a facial' },
      { image: US('1761718210089-ba3bb5ccb54f'), alt: 'Client relaxing during a cream facial treatment' },
    ],
    accent: '#CA8A04',
    aspect: 'aspect-square',
  },
  {
    id: 'nails_nail_art',
    label: 'Nails & Nail Art',
    kicker: 'Vol. V',
    blurb: 'Acrylics, builder gel, custom art.',
    photos: [
      { image: PX(18730147), alt: 'Close-up of hands showcasing artistic black and white nail art', credit: { name: 'honggyu kim', url: 'https://www.pexels.com/@honggyu-kim-582278127/' } },
      { image: US('1604654894610-df63bc536371'), alt: 'Hand with black and tortoiseshell nail art and a gold ring' },
      { image: US('1519014816548-bf5fe059798b'), alt: 'Pink manicure with hand-lettered nail art' },
    ],
    accent: '#C026D3',
    aspect: 'aspect-[3/4]',
  },
  {
    id: 'lashes_brows',
    label: 'Lashes & Brows',
    kicker: 'Vol. VI',
    blurb: 'Volume sets, lamination, tinting.',
    photos: [
      { image: PX(35013077), alt: 'Close-up of an eyelash extension being applied by a lash technician', credit: { name: 'Ekaterina Bogdanova', url: 'https://www.pexels.com/@ekaterina-bogdanova-345090620/' } },
      { image: US('1519415387722-a1c3bbef716c'), alt: 'Brow threading in progress on a client with brown skin' },
      { image: US('1735151225764-eac694642dbf'), alt: 'Lash technician placing individual extensions with tweezers' },
    ],
    accent: '#9333EA',
    aspect: 'aspect-[4/5]',
  },
  {
    id: 'makeup_glam',
    label: 'Make-up & Glam',
    kicker: 'Vol. VII',
    blurb: 'Bridal, editorial, soft glam, full glam. The finishing touch.',
    photos: [
      { image: PX(7510157), alt: 'Makeup artist applying foundation to a client with a brush', credit: { name: 'Chalo Garcia', url: 'https://www.pexels.com/@chalogarcia/' } },
      { image: US('1610173827043-9db50e0d8ef9'), alt: 'South Asian bride in red with gold jewellery and henna' },
      { image: US('1600685890506-593fdf55949b'), alt: 'Bride in traditional red attire with ornate gold jewellery' },
    ],
    accent: '#DB2777',
    aspect: 'aspect-[4/3]',
  },
];

// Short, tappable specialty chips per tile (ids match utils/specialties.py).
export const TILE_CHIPS = {
  locs_braids_protective: [['braids_knotless', 'Knotless'], ['faux_locs', 'Faux Locs'], ['loc_maintenance', 'Retwists']],
  barbering_grooming: [['fades_tapers', 'Fades'], ['beard_grooming', 'Beards'], ['textured_hair_barbering', 'Textured Hair']],
  hair_styling_care: [['silk_press', 'Silk Press'], ['curly_coily_specialist', 'Curly & Coily'], ['global_colour_styling', 'Colour']],
  aesthetics_skin: [['melanin_rich_skincare', 'Melanin-Rich Skin'], ['hyperpigmentation', 'Pigmentation'], ['threading_facials', 'Threading Facials']],
  nails_nail_art: [['biab', 'BIAB'], ['acrylic_extensions', 'Acrylics'], ['hand_painted_nail_art', 'Nail Art']],
  lashes_brows: [['eyebrow_threading', 'Threading'], ['lash_extensions', 'Lash Extensions'], ['sugaring', 'Sugaring']],
  makeup_glam: [['henna_mehndi', 'Henna'], ['south_asian_bridal', 'South Asian Bridal'], ['soft_glam', 'Soft Glam']],
};
